import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useLastPromptSignInPersistence(): useLastPromptSignInPersistenceReturn {
  return useLazyContext(LastPromptSignInPersistenceContext);
}

export const LastPromptSignInPersistenceContext =
  createContext<LazyValue<useLastPromptSignInPersistenceReturn>>(undefined);

export type useLastPromptSignInPersistenceReturn = {
  getLastPrompted: () => Promise<Date | undefined>;
  setLastPrompted: (date: Date) => Promise<void>;
};
